import { request } from 'lib/request';
import { getToken } from './auth';

export type BluDeltaVersion = 'v1-6';

export const bluDeltaVersion: BluDeltaVersion = 'v1-6';

export const bluDeltaEndpoint = '/api';

export interface BluDeltaResponse {
  State: 0 | 1;
  Message?: string;
}

export async function bludeltaResponseParser<R extends BluDeltaResponse = any>(
  response: R,
): Promise<R> {
  return new Promise<R>((resolve, reject) => {
      return resolve(response);
    if (response.State === 0) {
      return resolve(response);
    } else {
      return reject(new Error(response.Message || `Response state is: ${response.State}`));
    }
  });
}

export async function bludeltaRequest<R extends BluDeltaResponse>(
  method: string,
  url: string,
  body?: object,
  headers: Record<string, string> = {},
): Promise<R> {
  if (!headers['X-AccessToken']) {
    const token = getToken();
    if (token) {
      headers['X-AccessToken'] = token;
    }
  }

  // always necessary in the header because the API sometimes returns HTML when `Accept` header is not provided
  headers.Accept = 'application/json';
  return request<R>(method, `${bluDeltaEndpoint}${url}`, body, headers).then(
    bludeltaResponseParser,
  );
}
